// extracted by mini-css-extract-plugin
export default {"-large":"ZG4juB3o7rrS5eWdqzHi","line":"FUkQhdVFLTBRgB_tbHRz","viewAllText":"r5rOdWContWodTDWf7iH"};